import setLoading from 'components/loading';
import ReactDOMServer from "react-dom/server";
import downloadHtmlExport from './downloadHtmlExport';
import { CardsExport, CalendarExport } from './cardsExport';
import { exportToPDF } from 'utils';
import { today } from 'AppReact';
import { format } from 'date-fns';

export default {
  'ExportMakeReadyCards.ExportDropdown': ({ action, csvData, hiddenCards, cards, status, archived, properties, selectedPropertyIds, groups, selectedGroupIds, view, fileName,
    calendarSelectedDate,
    makeReadyCategories,
    selectedFloorplanIds,
    selectedTagIds,
    floorPlans,
    noTagIds,
    startMoveOutDate,
    startMoveInDate,
    endMoveOutDate,
    endMoveInDate,
    cardCounts
  }, outlet) => {
    let filters = [];

    const tags = [];

    makeReadyCategories.filter(c => c.type === 'tags' && c.active).map(makeReadyCategory => {
      makeReadyCategory.tags?.filter(t => t.status).map((c) => tags.push({ id: c.id, label: c.name, color: c.color }));
    })

    if (selectedPropertyIds?.length > 0) {
      filters.push(`Properties: ${selectedPropertyIds?.map(id => properties.find(f => f.id === id)?.name)?.join(', ')}`)
    }
    if (selectedGroupIds?.length > 0) {
      filters.push(`Groups: ${selectedGroupIds?.map(id => groups.find(f => f.id === id)?.name)?.join(', ')}`)
    }
    if (selectedFloorplanIds?.length > 0) {
      filters.push(`Floor plans: ${selectedFloorplanIds?.map(id => floorPlans.find(f => f.id === id)?.name)?.join(', ')}`)
    }
    if (selectedTagIds?.length > 0) {
      filters.push(`Tags: ${selectedTagIds?.map(id => tags.find(f => f.id === id)?.label)?.join(', ')}`)
    }
    if (startMoveInDate || endMoveInDate) {
      filters.push(`Move in date: ${startMoveInDate ? format(startMoveInDate, 'MM/dd/yyyy') : 'x'} - ${endMoveInDate ? format(endMoveInDate, 'MM/dd/yyyy') : 'x'}`)
    }
    if (startMoveOutDate || endMoveOutDate) {
      filters.push(`Move out date: ${startMoveOutDate ? format(startMoveOutDate, 'MM/dd/yyyy') : 'x'} - ${endMoveOutDate ? format(endMoveOutDate, 'MM/dd/yyyy') : 'x'}`)
    }

    if (action === 'pdf') {
      exportToPDF({
        data: csvData,
        title: `Make ready`,
        filters,
        fileName: `Make_Ready_Board_${cardCounts?.[status] ?? 0}_units_${status}_${filters.length > 0 ? 'with' : 'without'}_filters_${format(today(), 'MM_dd_yyyy')}.pdf`
      })
      // let html = null;

      // if (view === 'table' || 'grid') {
      //   html = ReactDOMServer.renderToString(CardsExport({ hiddenCards, cards, status, archived, properties, selectedPropertyIds, groups, selectedGroupIds, makeReadyCategories }));
      // }
      // if (view === 'list') {
      //   html = ReactDOMServer.renderToString(CalendarExport({ cards, status, properties, selectedPropertyIds, groups, selectedGroupIds, calendarSelectedDate }));
      // }
      // setLoading(true);
      // const promise = downloadHtmlExport.saveHtml({ html, options: { orientation: "Landscape" } });
      // promise.then((r) => {
      //   const source = `data:application/pdf;base64,${r.data}`;
      //   const link = document.createElement("a");
      //   link.href = source;
      //   link.download = `${fileName}.pdf`;
      //   link.click();
      // })
      // promise.catch((e) => {
      //   console.warn(e);
      //   setError(true);
      // });
      // promise.finally(() => setLoading(false));
    } else if (action === 'subscribe') {
      outlet({ action: 'subscribe' })
    }
  },
  'ExportMakeReadyCards.Csv': ({ }) => { },
  'ExportMakeReadyCards.Csv.CsvExport': ({ }) => { }
}
